// extracted by mini-css-extract-plugin
export var percentile = "styles-module--percentile--55002";
export var table = "styles-module--table--9620a";
export var value = "styles-module--value--358fb";
export var wrapper = "styles-module--wrapper--b252f";